import { useCallback, useMemo, useState } from "react";

import { LoadingSpinner } from "twyne-new.ui";

import InfiniteScroll from "@/components/Grid/components/Table/InfiniteScroll";

import { useVersionStore } from "../../store";

export default function Pagination({ onNextPage }) {
  const { collections: { hasNextPage }, loading } = useVersionStore()
  const shouldLoad = hasNextPage && !loading

  return <div className="flex w-full justify-center items-center h-14">
    {shouldLoad && <InfiniteScroll onVisit={onNextPage} hasMore={shouldLoad} />}
    {loading && <LoadingSpinner />}
  </div>
}

export function usePagination() {
  const [, setPage] = useState(0)
  const [sizePerPage, setSizePerPage] = useState(25)

  const onNextPage = useCallback(() => {
    setPage(page => {
      page = page + 1
      setSizePerPage(25 * 2 ** (page - 1))
      return page
    })
  }, [])

  return useMemo(() => ({
    onNextPage,
    options: {
      page: 1,
      sizePerPage,
    },
  }), [sizePerPage, onNextPage])
}
